var exports = {
  "Tc": "GuildTagLabel.module__tag___bGVGYW",
  "Kk": "GuildTagLabel.module__icon___bGVGYW",
  "md": "GuildTagLabel.module__md___bGVGYW",
  "vk": "GuildTagLabel.module__clickable___bGVGYW",
};

module.exports = exports;
